// GlitchTip/Sentry client-side filtering (used by index.js).
// Keeps browser-extension noise and content-free events out of GlitchTip, and
// blanks free-text search values in URLs (the call centre puts customer phone
// numbers in ?search=) before an event leaves the browser.

// Errors thrown by browser extensions or carrying no information at all.
export const IGNORE_ERRORS = [
  'Failed to connect to MetaMask',
  'Non-Error promise rejection captured with value: undefined',
  'The play() request was interrupted by a call to pause()',
];

export const DENY_URLS = [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-web-extension:\/\//];

const SENSITIVE_PARAMS = ['search', 'q', 'phone', 'email'];

export function scrubUrl(url) {
  if (typeof url !== 'string' || !url.includes('?')) return url;
  try {
    const u = new URL(url, 'https://placeholder.invalid');
    let changed = false;
    SENSITIVE_PARAMS.forEach((p) => {
      if (u.searchParams.has(p)) { u.searchParams.set(p, '[redacted]'); changed = true; }
    });
    if (!changed) return url;
    return url.startsWith('http') ? u.toString() : `${u.pathname}${u.search}${u.hash}`;
  } catch (e) {
    return url.split('?')[0];
  }
}

export function beforeSend(event) {
  if (event.request && event.request.url) event.request.url = scrubUrl(event.request.url);
  const headers = event.request && event.request.headers;
  if (headers && headers.Referer) headers.Referer = scrubUrl(headers.Referer);
  (event.breadcrumbs || []).forEach((b) => {
    if (!b || !b.data) return;
    ['url', 'from', 'to'].forEach((k) => { if (b.data[k]) b.data[k] = scrubUrl(b.data[k]); });
  });
  return event;
}
